module.exports = __webpack_public_path__ + "img/IMG_3506.007f2570.jpg";